import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
} from 'react'

type IHeader = {
  title?: string;
  goTo: any;
}

type PageContextProps = {
  header: IHeader;
  setHeader: React.Dispatch<React.SetStateAction<IHeader>>;
}

type IProps = {
  children: ReactNode;
}

const PageContext = createContext({} as PageContextProps)

const PageProvider = ({ children }: IProps) => {
  const [header, setHeader] = useState({} as IHeader)

  return (
    <PageContext.Provider
      value={{
        header,
        setHeader,
      }}
    >
      {children}
    </PageContext.Provider>
  )
}

export const usePage = () => {
  const context = useContext(PageContext)

  if (!context) {
    throw new Error('usePage must be used within a provider PageProvider')
  }

  return context
}

export default PageProvider
